const corporateLuxurySales = {
  'corporateLuxurySales.page.lastUpdated': '最終更新: 2026年6月13日',
  'corporateLuxurySales.page.backToTop': 'ページトップへ戻る',
  'corporateLuxurySales.jsonld.serviceName': 'ラグジュアリー営業向け接遇研修｜高額商談の体験を所作から設計',
  'corporateLuxurySales.jsonld.orgName': '一般社団法人全日本執事協会',
  'corporateLuxurySales.jsonld.serviceType': 'ラグジュアリー営業向け接遇研修',
  'corporateLuxurySales.jsonld.description': 'ラグジュアリー営業向け接遇研修。高額商談の体験を所作から設計し直す実技プログラム。半日220,000円税込〜、出張対応。輸入車・宝飾時計・高級不動産を対象。',
  'corporateLuxurySales.jsonld.breadcrumb1': 'ホーム',
  'corporateLuxurySales.jsonld.breadcrumb2': '法人研修',
  'corporateLuxurySales.jsonld.breadcrumb3': 'ラグジュアリー営業向け',
  'corporateLuxurySales.hero.homeLink': 'ホーム',
  'corporateLuxurySales.hero.corporateLink': '法人研修',
  'corporateLuxurySales.hero.currentPage': 'ラグジュアリー営業向け',
  'corporateLuxurySales.hero.title': 'ラグジュアリー営業向け 法人研修',
  'corporateLuxurySales.hero.titleEn': 'FOR LUXURY SALES',
  'corporateLuxurySales.hero.lead': 'ラグジュアリー営業向け研修は、日本の執事学校が手がける、高額商談の体験を所作から設計し直す、執事流の実技プログラムです。',
  'corporateLuxurySales.hero.targetNote': '対象: 高級輸入車ディーラー・宝飾時計サロン・高級不動産仲介',
  'corporateLuxurySales.hero.ctaBtn': 'この業種で相談する',
  'corporateLuxurySales.hero.imgAlt': 'ラグジュアリーショールームで丁寧に顧客をエスコートする日本人スタッフ',
  'corporateLuxurySales.hero.badge1': '高額商談の体験を所作から設計',
  'corporateLuxurySales.hero.badge2': '出張型で貴社のショールーム・モデルルームにて実施',
  'corporateLuxurySales.hero.badge3': '執事養成課程と同一の講師陣',
  'corporateLuxurySales.pain.title': 'こんな課題をお持ちではありませんか',
  'corporateLuxurySales.pain.subtitleEn': 'Common Challenges',
  'corporateLuxurySales.pain.lead': '数千万円の商談では、商品説明の上手さよりも、その場の体験の質が記憶に残ります。',
  'corporateLuxurySales.pain.item1': '商品力は十分なのに、接遇が価格帯の期待に追いついていません。数千万円の商談では、商品説明の上手さよりも、その場の体験の質が記憶に残ります。',
  'corporateLuxurySales.pain.item2': 'ショールーム・内見での「お迎えからお見送りまで」の一連が設計されておらず、担当者ごとの個人技に任されています。体験にムラがあることが、機会損失につながっています。',
  'corporateLuxurySales.pain.item3': '納車式・お引渡しという最大の見せ場を十分に演出し切れていません。せっかくの感動の瞬間が、手続きの延長になっていないでしょうか。',
  'corporateLuxurySales.pain.item4': '紹介でつながる市場ゆえ、一度の粗相が評判に響きます。高額商談ほど「誰から買うか」で選ばれるため、すべての接点で期待値を超える必要があります。',
  'corporateLuxurySales.why.title': '執事研修がラグジュアリー営業に効く理由',
  'corporateLuxurySales.why.subtitleEn': 'Why Butler Training Works',
  'corporateLuxurySales.why.lead1': '執事は富裕層の日常に最も近い場所で、もてなしの基準を体得してきた職業です。お客様の「当たり前の水準」から所作を組み立てます。',
  'corporateLuxurySales.why.lead2': '本研修が提供するのは、プロの執事が培った接遇の型を、貴社の現場で使えるビジネスマナーとして移植することです。',
  'corporateLuxurySales.why.item1.title': '富裕層の「当たり前の水準」から所作を組み立てる',
  'corporateLuxurySales.why.item1.desc': '執事は富裕層の生活様式と価値観を最も近くで学んできた職業です。お客様が日常的に経験しているサービスの水準を知る講師が、その目線から所作を組み立て直します。「これくらいで十分」ではなく「これが当然」から出発します。',
  'corporateLuxurySales.why.item2.title': 'モノの扱いを美しく見せる手元の技術',
  'corporateLuxurySales.why.item2.desc': '鍵・書類・宝飾品といった高額商材を扱う手元の所作は、お客様が無意識に注視しているポイントです。執事が培ってきた「モノを美しく扱う」手元の技術を実技で移植し、商談の説得力を高めます。',
  'corporateLuxurySales.why.item3.title': '商談を「売る場」から「もてなす場」へ変える',
  'corporateLuxurySales.why.item3.desc': '商談体験そのものを「もてなし」として設計することで、お客様の記憶に残り、紹介につながる関係性を築きます。押し付けがましさのない、自然な信頼構築の技術を提供します。',
  'corporateLuxurySales.programs.title': '推奨プログラム構成',
  'corporateLuxurySales.programs.subtitleEn': 'Program Examples for Luxury Sales',
  'corporateLuxurySales.programs.lead': '貴社の商材と商談フローに合わせて、最適な研修構成をご提案します。納車式やお引渡しの所作設計のみのご依頼も承ります。',
  'corporateLuxurySales.programs.recommended': '標準',
  'corporateLuxurySales.programs.currency': '円（税込）',
  'corporateLuxurySales.programs.p1.title': '半日プラン例',
  'corporateLuxurySales.programs.p1.duration': '3時間',
  'corporateLuxurySales.programs.p1.modules': 'M1（立ち居振る舞い）＋ M3（お茶出し・商談卓の整え実技）',
  'corporateLuxurySales.programs.p1.desc': 'ショールームやモデルルームでのお迎えから商談卓までの所作に集中する短期プランです。まずは基本の型を体得する導入研修としてご利用いただけます。',
  'corporateLuxurySales.programs.p2.title': '1日プラン例',
  'corporateLuxurySales.programs.p2.duration': '6時間',
  'corporateLuxurySales.programs.p2.modules': 'M1 ＋ M2（VIP・富裕層対応の原則）＋ M3 ＋ M4（同伴者対応・想定外対応ロールプレイング）',
  'corporateLuxurySales.programs.p2.desc': '所作からVIP対応、ご家族・同伴者への気配りまで、ラグジュアリー商談の接遇基盤を1日で網羅する推奨プランです。',
  'corporateLuxurySales.programs.p3.title': '納車式・お引渡しの所作設計',
  'corporateLuxurySales.programs.p3.duration': '1日（6時間）',
  'corporateLuxurySales.programs.p3.modules': '研修に加え、貴社の引渡しフローを執事の視点で組み直す回',
  'corporateLuxurySales.programs.p3.desc': '現状の引渡しフローを確認し、鍵や書類の差し出し方、布の掛け外し、記念のひとことまで、儀式としての一連を設計し実技で磨きます。',
  'corporateLuxurySales.programs.detailNote': 'モジュールの詳細は',
  'corporateLuxurySales.programs.detailLink': '法人研修総合ページ',
  'corporateLuxurySales.programs.detailSuffix': 'をご覧ください。',
  'corporateLuxurySales.scenario.title': 'ラグジュアリー営業特化の演習シナリオ',
  'corporateLuxurySales.scenario.subtitleEn': 'Luxury Sales Training Scenarios',
  'corporateLuxurySales.scenario.lead': '研修は貴社のショールームと商談フローを想定した実技で進めます。代表的なシナリオを三つご紹介します。シナリオは貴社の商材・商談フローに合わせて差し替え可能です。',
  'corporateLuxurySales.scenario.s1.title': 'ショールーム・内見のエスコート',
  'corporateLuxurySales.scenario.s1.desc': 'お出迎えの距離とタイミング、ご案内の歩く位置と速度、試乗・内見中の声がけと沈黙の使い分けを通しで演習します。お客様に「見られている」感覚を与えず、自然に商品の魅力を引き立てる所作を磨きます。',
  'corporateLuxurySales.scenario.s2.title': '納車式・お引渡しの所作',
  'corporateLuxurySales.scenario.s2.desc': '鍵や書類の両手での差し出し方、専用クロスの掛け外しの所作、記念のひとことまで、お引渡しを「儀式」として一連設計し実技で磨きます。お客様の人生の節目にふさわしい体験を、全担当者が同じ水準で実施できるようにします。',
  'corporateLuxurySales.scenario.s3.title': 'ご家族・同伴者への気配り',
  'corporateLuxurySales.scenario.s3.desc': 'お子様連れやご高齢の同伴者への席のご案内、年齢に応じた飲み物のご提案、商談中の同伴者の待ち時間への配慮をロールプレイングします。ご家族の満足度が、最終的なご成約を後押しするケースは少なくありません。',
  'corporateLuxurySales.scenario.note': '※シナリオは貴社の商材・商談フローに合わせて差し替え可能です。',
  'corporateLuxurySales.roles.title': '対象職種・推奨人数',
  'corporateLuxurySales.roles.subtitleEn': 'Target Roles & Capacity',
  'corporateLuxurySales.roles.lead': 'ショールーム・モデルルームでお客様と接するすべての職種の皆様にご受講いただけます。実技の品質を保つため、1回の研修は12名までを推奨しています。',
  'corporateLuxurySales.roles.r1': 'セールスコンサルタント',
  'corporateLuxurySales.roles.r2': 'ショールーム受付',
  'corporateLuxurySales.roles.r3': '店長・営業責任者',
  'corporateLuxurySales.roles.r4': '納車・引渡し担当',
  'corporateLuxurySales.roles.r5': 'カスタマーリレーション担当',
  'corporateLuxurySales.roles.capacity': '推奨12名まで',
  'corporateLuxurySales.roles.capacityNote': '超過する場合は2班制等をご提案します。ショールーム・モデルルームでの出張実施に対応し、閉店後の夜間開催も可能です。また、トップ営業1名へのプライベート研修（半日220,000円税込〜）も承ります。',
  'corporateLuxurySales.pricing.title': '料金プラン',
  'corporateLuxurySales.pricing.subtitleEn': 'Transparent Pricing',
  'corporateLuxurySales.pricing.lead': 'すべて税込価格での明確な料金体系です。貴社のご予算と目標に合わせて最適なプランをお選びいただけます。',
  'corporateLuxurySales.pricing.headerPlan': 'プラン',
  'corporateLuxurySales.pricing.headerTime': '時間',
  'corporateLuxurySales.pricing.headerPrice': '料金（税込）',
  'corporateLuxurySales.pricing.headerNote': '内容',
  'corporateLuxurySales.pricing.standard': '標準',
  'corporateLuxurySales.pricing.currency': '円',
  'corporateLuxurySales.pricing.p1.name': '半日プラン',
  'corporateLuxurySales.pricing.p1.duration': '3時間',
  'corporateLuxurySales.pricing.p1.note': '2モジュール選択',
  'corporateLuxurySales.pricing.p2.name': '1日プラン',
  'corporateLuxurySales.pricing.p2.duration': '6時間',
  'corporateLuxurySales.pricing.p2.note': '4モジュール選択',
  'corporateLuxurySales.pricing.p3.name': '2日間パッケージ',
  'corporateLuxurySales.pricing.p3.duration': '2日間（各6時間）',
  'corporateLuxurySales.pricing.p3.note': '全モジュール対応',
  'corporateLuxurySales.pricing.p4.name': '継続プログラム',
  'corporateLuxurySales.pricing.p4.duration': '月1回半日×6ヶ月',
  'corporateLuxurySales.pricing.p4.note': '定着と改善を繰り返す長期設計',
  'corporateLuxurySales.pricing.conditionsTitle': '共通条件',
  'corporateLuxurySales.pricing.conditions.dispatch': '出張時の交通費は実費別途',
  'corporateLuxurySales.pricing.conditions.capacity': '推奨12名まで。超過する場合は2班制等をご提案します',
  'corporateLuxurySales.pricing.conditions.payment': 'お支払いは請求書払い（銀行振込）。分割払い・クレジットカードはご利用いただけません。',
  'corporateLuxurySales.pricing.conditions.nightAvailable': 'ショールーム・モデルルームでの出張実施に対応。閉店後の夜間開催も可能です。',
  'corporateLuxurySales.pricing.conditions.cancel': 'キャンセルについて：実施7営業日前まで無償で日程変更可。6営業日前〜前々日は料金の50％、前日・当日は100％を申し受けます。',
  'corporateLuxurySales.pricing.allMenuNote': '継続プログラム・覆面サービス診断などの全メニューは',
  'corporateLuxurySales.pricing.allMenuLink': '法人研修総合ページ',
  'corporateLuxurySales.pricing.allMenuSuffix': 'をご覧ください。',
  'corporateLuxurySales.pricing.ctaBtn': '研修について問い合わせる',
  'corporateLuxurySales.flow.title': 'ご利用の流れ',
  'corporateLuxurySales.flow.subtitleEn': 'From Inquiry to Results',
  'corporateLuxurySales.flow.lead': 'お問い合わせから実施後レポートまで、5つのステップで着実に進めます。研修内容の事前資料をお送りできますので、稟議のご準備にもご活用ください。',
  'corporateLuxurySales.flow.step1.title': 'お問い合わせ',
  'corporateLuxurySales.flow.step1.desc': 'フォームまたはお電話・メールにてご連絡ください。',
  'corporateLuxurySales.flow.step2.title': 'ヒアリング',
  'corporateLuxurySales.flow.step2.desc': '商談フロー・課題・希望時期などをオンラインまたはお電話で伺います。事前に研修内容資料をお送りすることも可能です。',
  'corporateLuxurySales.flow.step3.title': 'プログラム提案・お見積り',
  'corporateLuxurySales.flow.step3.desc': 'ヒアリング内容をもとに、貴社に最適な研修プログラムとお見積りをご提案します。稟議用の概算お見積りのみのご依頼でも構いません。',
  'corporateLuxurySales.flow.step4.title': '実施',
  'corporateLuxurySales.flow.step4.desc': '出張または来校にて研修を実施します。貴社のショールーム・モデルルームでの出張型では、実際の商談動線で訓練でき再現性が高まります。',
  'corporateLuxurySales.flow.step5.title': '実施後レポート',
  'corporateLuxurySales.flow.step5.desc': '研修の総括と改善提案をまとめたレポートをお届けします。',
  'corporateLuxurySales.contact.title': 'お問い合わせ',
  'corporateLuxurySales.contact.subtitleEn': 'Inquiry Form',
  'corporateLuxurySales.contact.lead': '以下のフォームに必要事項をご入力のうえ、送信ください。',
  'corporateLuxurySales.contact.phoneNote': 'フォームのほか、お電話',
  'corporateLuxurySales.contact.emailNote': 'またはメール',
  'corporateLuxurySales.contact.emailSuffix': 'でも承ります。',
  'corporateLuxurySales.contact.hours': '受付時間: 平日 10:00〜17:00',
  'corporateLuxurySales.contact.labelCompany': '会社名',
  'corporateLuxurySales.contact.placeholderCompany': '例: 株式会社〇〇',
  'corporateLuxurySales.contact.labelDepartment': '部署・役職',
  'corporateLuxurySales.contact.placeholderDepartment': '例: 営業企画部',
  'corporateLuxurySales.contact.labelName': 'ご担当者名',
  'corporateLuxurySales.contact.placeholderName': '例: 執事 太郎',
  'corporateLuxurySales.contact.required': '必須',
  'corporateLuxurySales.contact.labelEmail': 'メールアドレス',
  'corporateLuxurySales.contact.placeholderEmail': '例: taro@example.com',
  'corporateLuxurySales.contact.labelPhone': '電話番号',
  'corporateLuxurySales.contact.placeholderPhone': '例: 090-1234-5678',
  'corporateLuxurySales.contact.labelBusinessType': '業態',
  'corporateLuxurySales.contact.labelFormat': '希望形式',
  'corporateLuxurySales.contact.labelParticipants': '想定人数',
  'corporateLuxurySales.contact.placeholderParticipants': '例: 10名',
  'corporateLuxurySales.contact.labelTimeline': '検討時期',
  'corporateLuxurySales.contact.placeholderTimeline': '例: 来月、今期中、未定',
  'corporateLuxurySales.contact.labelMessage': 'ご相談内容（任意）',
  'corporateLuxurySales.contact.placeholderMessage': '研修の目的やご要望、ご不明な点など、自由にご記入ください。',
  'corporateLuxurySales.contact.errorName': 'ご担当者名は必須です',
  'corporateLuxurySales.contact.errorEmailRequired': 'メールアドレスは必須です',
  'corporateLuxurySales.contact.errorEmailInvalid': '有効なメールアドレスを入力してください',
  'corporateLuxurySales.contact.errorPhone': '電話番号は必須です',
  'corporateLuxurySales.contact.errorBusinessType': '業態をお選びください',
  'corporateLuxurySales.contact.errorMessageLength': '500文字以内で入力してください',
  'corporateLuxurySales.contact.errorSubmit': '送信中にエラーが発生しました。お手数ですが再度お試しいただくか、お電話にてお問い合わせください。',
  'corporateLuxurySales.contact.submitBtn': 'この内容で送信する',
  'corporateLuxurySales.contact.submitting': '送信中...',
  'corporateLuxurySales.contact.businessType.select': '選択してください',
  'corporateLuxurySales.contact.businessType.importCar': '輸入車',
  'corporateLuxurySales.contact.businessType.domesticLuxuryCar': '国産高級車',
  'corporateLuxurySales.contact.businessType.jewelryWatch': '宝飾時計',
  'corporateLuxurySales.contact.businessType.luxuryRealestate': '高級不動産',
  'corporateLuxurySales.contact.businessType.other': 'その他',
  'corporateLuxurySales.contact.format.select': '選択してください',
  'corporateLuxurySales.contact.format.onsite': '来校',
  'corporateLuxurySales.contact.format.dispatch': '出張',
  'corporateLuxurySales.contact.format.private': 'プライベート研修（1名）',
  'corporateLuxurySales.contact.format.undecided': '未定',
  'corporateLuxurySales.faq.title': 'よくあるご質問',
  'corporateLuxurySales.faq.subtitleEn': 'Frequently Asked Questions',
  'corporateLuxurySales.faq.otherNote': 'その他のご質問はフォームよりお寄せください',
  'corporateLuxurySales.faq.q1': '執事の資格が取れる研修ですか？',
  'corporateLuxurySales.faq.a1': 'いいえ。執事の接遇スキルに基づくビジネスマナー研修であり、資格を付与するものではありません。ご希望に応じて受講証（参加証明）を発行します。',
  'corporateLuxurySales.faq.q2': '納車式やお引渡しの演出設計だけを依頼できますか？',
  'corporateLuxurySales.faq.a2': 'はい。「納車式・お引渡しの所作設計（1日）」として、現状フローの確認から所作の組み直し、通し稽古までを1日で行います。',
  'corporateLuxurySales.faq.q3': '自社の商談フローに合わせてもらえますか？',
  'corporateLuxurySales.faq.a3': 'はい。ヒアリングで商談の流れを伺い、演習シナリオを貴社仕様に差し替えて実施します。貴社の商材やお客様層に即した内容で研修を組み立てます。',
  'corporateLuxurySales.faq.q4': 'トップ営業1名への個人指導はできますか？',
  'corporateLuxurySales.faq.a4': 'プライベート研修（半日220,000円税込〜）として承ります。内容と会場はご相談ください。',
  'corporateLuxurySales.cta.title': 'まずはお気軽にご相談ください',
  'corporateLuxurySales.cta.lead': '納車式・お引渡しの所作設計のみのご依頼も承ります。現状のお引渡しの流れをお聞かせください。',
  'corporateLuxurySales.cta.lead2': '貴社の商談フローやご状況をお聞かせいただければ、最適な研修プランを無料でご提案いたします。',
  'corporateLuxurySales.cta.inquiryBtn': '研修について問い合わせる',
  'corporateLuxurySales.cta.coursesBtn': '個人向けコースを見る',
  'corporateLuxurySales.related.title': '他の業種向けプログラム',
  'corporateLuxurySales.related.subtitleEn': 'Training for Other Industries',
  'corporateLuxurySales.related.viewDetail': '詳しく見る',
  'corporateLuxurySales.related.backToCorpBtn': '法人研修総合ページへ戻る',
  'corporateLuxurySales.related.coursesBtn': '個人向けコース（執事養成課程）を見る',
  'corporateLuxurySales.related.r1.title': 'ホテル・旅館',
  'corporateLuxurySales.related.r1.desc': 'バトラーサービスの型を開業前に整える',
  'corporateLuxurySales.related.r2.title': '高級レジデンス',
  'corporateLuxurySales.related.r2.desc': 'コンシェルジュ・フロントの接遇品質を統一',
  'corporateLuxurySales.related.r3.title': '金融・プライベートバンク',
  'corporateLuxurySales.related.r3.desc': '富裕層営業の所作と距離感を鍛える',
  'corporateLuxurySales.related.r4.title': '百貨店外商・高級小売',
  'corporateLuxurySales.related.r4.desc': 'お得意様対応と訪問の作法',
  'corporateLuxurySales.related.r5.title': '医療・美容クリニック',
  'corporateLuxurySales.related.r5.desc': '自由診療の接遇を院内に定着',
  'corporateLuxurySales.related.r6.title': '自動車・モビリティ',
  'corporateLuxurySales.related.r6.desc': 'ブランド体験の接遇を高める',
  'corporateLuxurySales.related.r7.title': 'ハイヤー・送迎',
  'corporateLuxurySales.related.r7.desc': '乗降の所作と車内の気配りを磨く',
};

export default corporateLuxurySales;
